/* Termos comuns utilizados em todo o sistema */
export const CommonTranslations = {
  // botões padrões
  BUTTON_CANCEL: 'btn_cancel',
  BUTTON_DELETE: 'btn_del',
  BUTTON_NEW: 'btn_new',
  BUTTON_SAVE: 'btn_save',

  // checkboxes padrões
  CHECKBOX_ATIVO: 'chk_ativo',
  CHECKBOX_INATIVO: 'chk_inativo',

  // colunas de grids
  GRID_COLUMN_ACOES: 'grid_col_acoes',

  // itens de abas - geral
  TABSHEET_GERAL: 'tabsheet_geral',

  // labels padrões
  LABEL_PASSWORD: 'lbl_pwd',
  LABEL_PDV: 'lbl_pdv',
  LABEL_USER: 'lbl_user',

  // -------------------------------------------------------------------------------------------

  // menus - geral
  MENU_CADASTRO: 'menu_cad',
  MENU_DASHBOARD: 'menu_dash',
  MENU_OPCOES: 'menu_opt',
  MENU_PROCEDIMENTOS: 'menu_proced',
  MENU_SAIR: 'menu_sair',

  // itens de menu - geral
  MENU_ITEM_CATEGORIA_SERVICO: 'menu_item_categ_serv',
  MENU_ITEM_CLIENTE: 'menu_item_cli',
  MENU_ITEM_FERIADO: 'menu_item_feriado',
  MENU_ITEM_FUNCIONARIO: 'menu_item_func',
  MENU_ITEM_ORDEM_SERVICO: 'menu_item_os',
  MENU_ITEM_PAIS: 'menu_item_pais',
  MENU_ITEM_SERVICO: 'menu_item_serv',
  MENU_ITEM_TIPO_VEICULO: 'menu_item_tipo_veic',
  MENU_ITEM_USUARIO: 'menu_item_user',
  MENU_ITEM_VEICULO: 'menu_item_veic',

  // menus do módulo Adm AppCli
  MENU_PASSENGER: 'menu_passenger',

  // itens de menu do módulo Adm AppCli
  MENU_ITEM_ANALYTICS: 'menu_item_analytics',
  MENU_ITEM_PASSAGEIRO: 'menu_item_pax',

  // itens de menu do módulo Adm Partner
  MENU_ITEM_AGENDA_ESCALA: 'menu_item_agenda_esc',
  MENU_ITEM_USUARIO_PARTNER: 'menu_item_user_partner',

  // itens de menu do módulo CRM
  MENU_ITEM_CANAL_VENDA: 'menu_item_canal_venda',
  MENU_ITEM_CLASSIFICACAO_SAC: 'menu_item_classif_sac',
  MENU_ITEM_CONTATO_AVULSO: 'menu_item_ctt_avulso',
  MENU_ITEM_ATENDIMENTO_SAC: 'menu_item_atend_sac',
  MENU_ITEM_FOLLOW_UP: 'menu_item_flw_up',
  MENU_ITEM_GRUPO_CONTATO_AVULSO: 'menu_item_grp_ctt_avulso',
  MENU_ITEM_SAC: 'menu_item_sac',
  MENU_ITEM_SUBCLASSIFICACAO_SAC: 'menu_item_subclassif_sac',
  MENU_ITEM_WHATSAPP: 'menu_item_wpp',
  MENU_ITEM_WHATSAPP_CHAT: 'menu_item_wpp_chat',
  MENU_ITEM_WHATSAPP_ENVIO: 'menu_item_wpp_envio',
  MENU_ITEM_WHATSAPP_GRUPO_MENSAGEM: 'menu_item_wpp_grp_msg',
  MENU_ITEM_WHATSAPP_MENSAGEM: 'menu_item_wpp_msg',

  // itens de menu do módulo Estoque
  MENU_ITEM_GRUPO_MERCADORIA: 'menu_item_grp_merc',
  MENU_ITEM_MERCADORIA: 'menu_item_merc',
  MENU_ITEM_UNIDADE: 'menu_item_unid',

  // menus do módulo Finanças
  MENU_FECHAMENTO_FINANCEIRO: 'menu_fch_financ',

  // itens de menu do módulo Finanças
  MENU_ITEM_BANCO: 'menu_item_bco',
  MENU_ITEM_CONTA_CORRENTE: 'menu_item_cc',
  MENU_ITEM_EXECUTAR_FECHAMENTO: 'menu_item_exec_fch',
  MENU_ITEM_HISTORICO_BANCARIO: 'menu_item_hist_banc',
  MENU_ITEM_HISTORICO_FECHAMENTO: 'menu_item_hist_fch',
  MENU_ITEM_SETOR: 'menu_item_st',
  MENU_ITEM_TIPO_DOCUMENTO: 'menu_item_tipo_doc',
  MENU_ITEM_TRANSACAO: 'menu_item_txn',

  // itens de menu do módulo Front
  MENU_ITEM_EXPORTACAO: 'menu_item_exp',
  MENU_ITEM_MOTIVO_CANCELAMENTO: 'menu_item_mtv_canc',
  MENU_ITEM_SNOWLAND: 'menu_item_snowland',
  MENU_ITEM_VENDEDOR: 'menu_item_vend',

  // itens de menu do módulo Frotas
  MENU_ITEM_ABASTECIMENTO: 'menu_item_abast',
  MENU_ITEM_ABASTECIMENTO_LANCAR: 'menu_item_abast_lcto',
  MENU_ITEM_MARCA_VEICULO: 'menu_item_marca_veic',
  MENU_ITEM_MODELO_VEICULO: 'menu_item_model_veic',
  MENU_ITEM_OPCIONAL_VEICULO: 'menu_item_opc_veic',
  MENU_ITEM_ORDEM_SERVICO_MANUTENCAO: 'menu_item_os_manut',

  // itens de menu do módulo Gerencial
  MENU_ITEM_ADMINISTRATIVO: 'menu_item_admin',
  MENU_ITEM_FINANCEIRO: 'menu_item_financ',
  MENU_ITEM_OPERACIONAL: 'menu_item_operac',
  MENU_ITEM_PRODUCAO: 'menu_item_prod'
};

/* Chaves de tradução dos labels do dashboard do módulo Front */
export const Dashboard_Translations = {
  LABEL_CHEGADAS: 'lbl_dash_chegadas',
  LABEL_PARTIDAS: 'lbl_dash_partidas',
  LABEL_PAX_DESTINO: 'lbl_dash_pax_destino'
};

/* Chaves de tradução do formulário de OS */
export const Form_OS_Translations = {
  FORM_ORDEM_SERVICO_TITLE: 'form_OS_title'
};

/* Chaves de tradução do formulário de categoria de serviço */
export const Form_Categoria_Servico_Translations = {
  FORM_CATEGORIA_SERVICO_TITLE: 'form_categ_serv_title'
};

/* Chaves de tradução da listagem de categoria de serviço */
export const list_Categoria_Servico_Translations = {
  LIST_CATEGORIA_SERVICO_TITLE: 'list_categ_serv_grid_column'
};